import { InputTextAccordionProps } from "./types"
import React from "react"
import { Accordion } from "~widgets/accordion"
import { InputTextBorder } from "~components/input-text"
import styled from '~/ui/styled'

const InputWrap = styled.View`
  width: 100%;
  padding: 10px 0px;
`

const InputTextAccordion: React.FC<InputTextAccordionProps> = ({
  accordionProps,
  inputTextProps,
}) => {
  return (
    <Accordion {...accordionProps}>
      <InputWrap>
        <InputTextBorder {...inputTextProps} />
      </InputWrap>
    </Accordion>
  )
}
export default InputTextAccordion
